<template>
  <div v-if="visible" class="pay-picker" @click.self="$emit('close')">
    <div class="pay-picker-card">
      <div class="pay-picker-title">{{ title }}</div>
      <div v-if="subtitle" class="pay-picker-sub">{{ subtitle }}</div>
      <div class="pay-type-row pay-type-row-picker">
        <label class="pay-type-item">
          <input type="radio" value="wechat" v-model="payType" />
          <img class="pay-logo" :src="wechatLogo" alt="微信支付" />
          <span>微信</span>
        </label>
        <label class="pay-type-item">
          <input type="radio" value="alipay" v-model="payType" />
          <img class="pay-logo" :src="alipayLogo" alt="支付宝" />
          <span>支付宝</span>
        </label>
      </div>
      <div class="pay-picker-actions">
        <button type="button" class="ghost-btn" @click="$emit('close')">取消</button>
        <button type="button" class="main-btn" @click="onConfirm">去付款</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayMethodPicker",
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "选择支付方式" },
    subtitle: { type: String, default: "" },
    defaultPayType: { type: String, default: "wechat" }
  },
  data() {
    return {
      payType: "wechat",
      wechatLogo: require("@/assets/pay/wechatpay.svg"),
      alipayLogo: require("@/assets/pay/alipay.svg")
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.payType = this.defaultPayType === "alipay" ? "alipay" : "wechat";
      }
    },
    defaultPayType(val) {
      if (this.visible) {
        this.payType = val === "alipay" ? "alipay" : "wechat";
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit("confirm", { payType: this.payType });
    }
  }
};
</script>

<style scoped>
.pay-picker {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10002;
}
.pay-picker-card {
  width: 360px;
  max-width: calc(100vw - 32px);
  background: rgba(20, 20, 20, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  padding: 16px 16px 14px;
  color: #fff;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
}
.pay-picker-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
}
.pay-picker-sub {
  font-size: 14px;
  color: #bdbdbd;
  margin-bottom: 10px;
}
.pay-type-row {
  margin: 10px 0;
  display: flex;
  gap: 12px;
  justify-content: center;
  font-size: 14px;
}
.pay-type-row-picker {
  justify-content: flex-start;
  gap: 10px;
}
.pay-type-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
}
.pay-type-item input {
  margin: 0;
}
.pay-logo {
  width: 32px;
  height: 32px;
  display: block;
}
.pay-picker-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}
.ghost-btn {
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
}
.main-btn {
  border: none;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  background: linear-gradient(135deg, #e8c76a, #b8922a);
  color: #1a1a1a;
  font-weight: 600;
}
</style>
